import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  BumpMinimumPriceDto,
  BumpMinimumPriceModel,
  BumpMinimumPriceResp,
  BumpMinimumPriceSvcVasDto,
  BumpMinimumPriceSvcVasResp,
} from '../types/bump-minimum-price'
import { transformCurrencyAmountDto, transformCurrencyDto } from './currency'

export const transformBumpMinimumPrice = (dto: BumpMinimumPriceDto): BumpMinimumPriceModel => ({
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  hasFreeBump: dto.has_free_bump,
})

export const transformBumpMinimumPriceResponse = (response: Response<BumpMinimumPriceResp>) =>
  transformBumpMinimumPrice(response.minimum_price)

export const transformBumpMinimumPriceSvcVas = (
  dto: BumpMinimumPriceSvcVasDto,
): BumpMinimumPriceModel => ({
  total: transformCurrencyDto(dto.base_price),
  payable: transformCurrencyDto(dto.final_price),
  discount: transformCurrencyDto(dto.discount_amount),
  hasFreeBump: dto.has_free_bumps,
})

export const transformBumpMinimumPriceSvcVasResponse = (
  response: Response<BumpMinimumPriceSvcVasResp>,
) => transformBumpMinimumPriceSvcVas(response.minimum_price)
